export default "__VITE_ASSET__393a1fc7__"